// Single source of truth for chain metadata across the frontend.
// Flip REACT_APP_NETWORK_ENV=testnet|mainnet at build time to switch
// every explorer URL, chain id, and default RPC at once.

export const NETWORK_ENV = (process.env.REACT_APP_NETWORK_ENV || 'testnet').toLowerCase();

const CHAINS = {
  ethereum: {
    testnet: {
      chainId: 11155111,
      name: 'Sepolia',
      label: 'Ethereum',
      explorer: 'https://sepolia.etherscan.io',
      defaultRpc: 'https://ethereum-sepolia-rpc.publicnode.com',
    },
    mainnet: {
      chainId: 1,
      name: 'Ethereum',
      label: 'Ethereum',
      explorer: 'https://etherscan.io',
      defaultRpc: 'https://ethereum-rpc.publicnode.com',
    },
  },
  bsc: {
    testnet: {
      chainId: 97,
      name: 'BSC Testnet',
      label: 'BSC',
      explorer: 'https://testnet.bscscan.com',
      defaultRpc: 'https://bsc-testnet-rpc.publicnode.com',
    },
    mainnet: {
      chainId: 56,
      name: 'BSC',
      label: 'BSC',
      explorer: 'https://bscscan.com',
      defaultRpc: 'https://bsc-rpc.publicnode.com',
    },
  },
  tron: {
    testnet: {
      name: 'Shasta',
      label: 'TRON',
      explorer: 'https://shasta.tronscan.org',
      defaultApi: 'https://api.shasta.trongrid.io',
    },
    mainnet: {
      name: 'TRON',
      label: 'TRON',
      explorer: 'https://tronscan.org',
      defaultApi: 'https://api.trongrid.io',
    },
  },
};

export function chainConfig(chain) {
  const c = CHAINS[chain];
  if (!c) throw new Error(`Unknown chain: ${chain}`);
  return c[NETWORK_ENV] || c.testnet;
}

export function txUrl(chain, txHash) {
  if (!txHash) return null;
  const cfg = chainConfig(chain);
  if (chain === 'tron') return `${cfg.explorer}/#/transaction/${txHash}`;
  return `${cfg.explorer}/tx/${txHash}`;
}

export function addressUrl(chain, address) {
  if (!address) return null;
  const cfg = chainConfig(chain);
  if (chain === 'tron') return `${cfg.explorer}/#/address/${address}`;
  return `${cfg.explorer}/address/${address}`;
}

export const BSC_CHAIN_ID = chainConfig('bsc').chainId;
export const ETH_CHAIN_ID = chainConfig('ethereum').chainId;
